import { Component, OnInit } from '@angular/core';
import { cloneDeep, filter, findIndex, forEach, map, orderBy, reject, sortBy } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { Modalconfig } from 'src/app/shared/constants';
import { SectionsForPageViewModel } from 'src/app/shared/model/container.models';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';

@Component({
    selector: 'app-apply-draft',
    templateUrl: './apply-draft.component.html',
    styleUrls: ['./apply-draft.component.scss'],
    standalone: false
})
export class ApplyDraftComponent implements OnInit {
  allSections: Array<SectionsForPageViewModel> = [];
  draftPages: Array<any> = [];
  constAllSections: Array<SectionsForPageViewModel> = [];
  selectedSectionsDraft: Array<SectionsForPageViewModel> = [];
  selectedSectionsDraftId: Array<any> = [];
  selectedSectionsLive: Array<SectionsForPageViewModel> = [];
  selectedSectionsLiveId: Array<any> = [];
  deletedSections: Array<SectionsForPageViewModel> = [];
  playbookId: number;
  pageId: number;
  draftSaved = new Subject();
  draftDeleted = new Subject();
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  constructor(
    private modalRef: BsModalRef,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.allSections = sortBy(this.allSections, 'orderBy');
    forEach(this.allSections, (eachAllSection, index) => {
      eachAllSection.oldOrderBy = null;
      eachAllSection.orderBy = index;
    });
    this.constAllSections = cloneDeep(this.allSections);
  }

  checkReplaceButton(): boolean {
    let returnFlag = false;
    const draftSections = filter(this.allSections, (eachAllSection) => eachAllSection.isDraftMode);

    if (draftSections && draftSections.length) {
      const deletedDraftSections = filter(draftSections, (eachDraftSections) => eachDraftSections.isDeleted);
      const userDeletedDraftSections = filter(draftSections, (eachDraftSections) => eachDraftSections.isDeletedByUser);
      if (draftSections.length === (userDeletedDraftSections.length + deletedDraftSections.length)) {
        returnFlag = true;
      }
    } else {
      returnFlag = true;
      if (this.draftPages && this.draftPages.length) {
        returnFlag = false;
      }
    }
    return returnFlag;
  }
  getTitle(eachDraftSection: SectionsForPageViewModel): string {
    let message = '';
    if (eachDraftSection.isDraftMode) {
      message = 'Section in draft mode.';
      if (eachDraftSection.isMoved) {
        message = 'Moved from live mode.';
      }
    } else {
      message = 'Section in live mode.';
      if (eachDraftSection.isMoved) {
        message = 'Applied draft section.';
      }
    }
    return message;
  }
  optionLiveSelected() {
    if (this.selectedSectionsLiveId.length) {
      this.selectedSectionsDraftId = [];
      this.selectedSectionsDraft = [];
      const liveIndex = findIndex(this.allSections, (eachLiveSection) => eachLiveSection.sectionId === +this.selectedSectionsLiveId[0]);
      this.selectedSectionsLive[0] = this.allSections[liveIndex];
    }
  }
  openDraftSelected() {
    if (this.selectedSectionsDraftId.length) {
      this.selectedSectionsLiveId = [];
      this.selectedSectionsLive = [];
      const draftIndex = findIndex(this.allSections, (eachDraftSection) => eachDraftSection.sectionId === +this.selectedSectionsDraftId[0]);
      this.selectedSectionsDraft[0] = this.allSections[draftIndex];
    }
  }
  delete() {
    if (this.selectedSectionsLive.length > 0) {
      this.selectedSectionsLive[0].isDeletedByUser = true;
      this.selectedSectionsLive[0].sectionTitle += ' (Original)';
      this.deletedSections.push(...this.selectedSectionsLive);

      const liveIndex = findIndex(this.allSections, (eachLiveSection) => eachLiveSection.sectionId === +this.selectedSectionsLiveId[0]);
      this.allSections.splice(liveIndex, 1);
      this.selectedSectionsLive = [];
      this.selectedSectionsLiveId = [];
    }
    if (this.selectedSectionsDraft.length > 0) {
      this.selectedSectionsDraft[0].isDeletedByUser = true;
      this.selectedSectionsDraft[0].sectionTitle += ' (Draft)';
      this.deletedSections.push(...this.selectedSectionsDraft);

      const DraftIndex = findIndex(this.allSections, (eachDraftSection) => eachDraftSection.sectionId === +this.selectedSectionsDraftId[0]);
      this.allSections.splice(DraftIndex, 1);
      this.selectedSectionsDraft = [];
      this.selectedSectionsDraftId = [];
    }
  }
  resetAll() {
    const initialState = {
      msg: 'Are you sure you want to reset the sections list?'
    };
    this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
    this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((isResetAll: boolean) => {
      if (isResetAll) {
        this.allSections = cloneDeep(this.constAllSections);
        this.deletedSections = [];
      }
      this.confirmationModalRef.hide();
      this.confModalSubsciber.unsubscribe();
    });
  }
  /**
   * To close the modal
   */
  closeModal() {
    this.modalRef.hide();
  }
  replaceAll() {
    forEach(this.allSections, (eachAllSection) => {
      if (eachAllSection.isDraftMode && !eachAllSection.isDeleted && !eachAllSection.isDeletedByUser) {
        const matchingLiveSection = filter(this.allSections, (currentAllSections) =>
          currentAllSections.sectionId === eachAllSection.refContainerId);
        const totalLiveSections = (filter(this.allSections, (currentAllSections) => !currentAllSections.isDraftMode)).length;
        if (matchingLiveSection && matchingLiveSection.length) {
          eachAllSection.orderBy = matchingLiveSection[0].orderBy;
          matchingLiveSection[0].isDeleted = true;
          if (!matchingLiveSection[0].isDeletedByUser) {
            const currentLiveSection = cloneDeep(matchingLiveSection);
            currentLiveSection[0].sectionTitle += ' (Original)';
            this.deletedSections.push(...currentLiveSection);
          }
        } else {
          eachAllSection.orderBy = totalLiveSections + 1;
        }
        eachAllSection.isDraftMode = false;
        eachAllSection.isMoved = true;
      }
    });
    this.selectedSectionsDraft.length = 0;
    this.selectedSectionsDraftId.length = 0;
    this.allSections = orderBy(this.allSections, ['orderBy']);
    this.allSections = this.updateOrder(this.allSections, false);
  }

  updateOrder(array: Array<SectionsForPageViewModel>, isDraftMode: boolean) {
    let tempArray1: Array<SectionsForPageViewModel> = []; // for currently working
    let tempArray2: Array<SectionsForPageViewModel> = []; // for appending later
    let nonDeletedSections: Array<SectionsForPageViewModel> = [];
    let deletedSections: Array<SectionsForPageViewModel> = [];
    let counter = 0;
    map(array, (eachContent) => (eachContent.isDraftMode) ? tempArray1.push(eachContent) : tempArray2.push(eachContent));

    forEach(tempArray1, (val) => (val.isDeleted || val.isDeletedByUser) ? deletedSections.push(val) : nonDeletedSections.push(val));

    forEach(nonDeletedSections, (val) => {
      val.orderBy = counter;
      counter++;
    });
    forEach(deletedSections, (val) => {
      val.orderBy = counter;
      counter++;
    });
    tempArray1 = orderBy(tempArray1, ['orderBy', 'isDeleted']);

    nonDeletedSections = [];
    deletedSections = [];
    counter = 0;
    forEach(tempArray2, (val) => (val.isDeleted || val.isDeletedByUser) ? deletedSections.push(val) : nonDeletedSections.push(val));

    forEach(nonDeletedSections, (val) => {
      val.orderBy = counter;
      counter++;
    });
    forEach(deletedSections, (val) => {
      val.orderBy = counter;
      counter++;
    });
    tempArray2 = orderBy(tempArray2, ['orderBy', 'isDeleted']);
    return isDraftMode ? tempArray2.concat(tempArray1) : tempArray1.concat(tempArray2);
  }
  save() {
    const newObj = [];
    let counter = 0;
    let isShowLeaveDraft = false;
    forEach(this.deletedSections, (eachDeletedSections) => {
      const deletedIndex = findIndex(this.allSections, (eachAllSections) => eachDeletedSections.sectionId === eachAllSections.sectionId);
      if (deletedIndex === -1) {
        this.allSections.push(eachDeletedSections);
      }
    });
    forEach(this.allSections, (obj) => {
      if (!obj.isDraftMode) {
        if (obj.isDeletedByUser) {
          obj.isDeleted = true;
        }
        obj.orderBy = counter;
        newObj.push(obj);
        counter++;
      }
    });
    counter = 0;
    forEach(this.allSections, (obj) => {
      if (obj.isDraftMode) {
        if (obj.isDeletedByUser) {
          obj.isDeleted = true;
        }
        if (!obj.isDeleted) {
          isShowLeaveDraft = true;
        }
        obj.orderBy = counter;
        newObj.push(obj);
        counter++;
      }
    });
    if (newObj && newObj.length > 0) {
      this.commonHttpService.post({
        uri: `/api/PlaybookDraft/ManageSectionsForPage`,
        object: {
          playbookId: this.playbookId,
          pageId: this.pageId,
          sections: newObj
        }
      }).subscribe(responseData => {
        this.draftSaved.next(isShowLeaveDraft);
        this.closeModal();
      });
    }
  }
  deleteDraft() {
    const initialState = {
      msg: 'Deleting this section will delete the associated page(s) in Draft Mode. Do you wish to continue?'
    };
    this.confirmationModalRef = this.modalService.show(ConfirmationModelComponent,
      Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
    this.confModalSubsciber = this.confirmationModalRef.content.onclose.subscribe((isDeleteDraftMode: boolean) => {
      if (isDeleteDraftMode) {
        this.commonHttpService.delete({
          uri: `/api/PlaybookDraft/DeleteAllDraftSectionsForPage?pageId=${this.pageId}&playbookId=${this.playbookId}`,
          message: {
            successMessage: 'Draft Mode Successfully deleted.',
            errorMessage: 'Something went wrong while deleting draft mode.'
          }
        }).subscribe(responseData => {
          this.draftDeleted.next(true);
          this.closeModal();
        });
      }
      this.confirmationModalRef.hide();
      this.confModalSubsciber.unsubscribe();
    });
  }
  moveSelectedUp(listarray: Array<SectionsForPageViewModel>, selectedarray: Array<SectionsForPageViewModel>) {
    const selection = filter(listarray, (item) => selectedarray[0].sectionId === item.sectionId);
    let prevIdx = -1;
    forEach(selection, (eachSelection) => {
      const idx = listarray.indexOf(eachSelection);
      if (idx - 1 === prevIdx) {
        prevIdx = idx;
      } else if (idx > 0) {
        const itemToMove = listarray.splice(idx, 1);
        listarray.splice(idx - 1, 0, itemToMove[0]);
      }
    });
  }
  moveSelectedDown(listarray: Array<SectionsForPageViewModel>, selectedarray: Array<SectionsForPageViewModel>) {
    const selection = filter(listarray, (item) => selectedarray[0].sectionId === item.sectionId);
    let prevIdx = listarray.length;
    const revArray = selection.concat();
    revArray.reverse();
    forEach(revArray, (eachRevArray) => {
      const idx = listarray.indexOf(eachRevArray);
      if (idx + 1 === prevIdx) {
        prevIdx = idx;
      } else if (idx < listarray.length - 1) {
        const itemToMove = listarray.splice(idx, 1);
        listarray.splice(idx + 1, 0, itemToMove[0]);
      }
    });
  }
  moveUp() {
    if (this.selectedSectionsLive.length > 0) {
      this.moveSelectedUp(this.allSections, this.selectedSectionsLive);
      this.allSections = this.updateOrder(this.allSections, false);
    }
    if (this.selectedSectionsDraft.length > 0) {
      this.moveSelectedUp(this.allSections, this.selectedSectionsDraft);
      this.allSections = this.updateOrder(this.allSections, true);
    }
  }
  moveDown() {
    if (this.selectedSectionsLive.length > 0) {
      this.moveSelectedDown(this.allSections, this.selectedSectionsLive);
      this.allSections = this.updateOrder(this.allSections, false);
    }
    if (this.selectedSectionsDraft.length > 0) {
      this.moveSelectedDown(this.allSections, this.selectedSectionsDraft);
      this.allSections = this.updateOrder(this.allSections, true);
    }
  }
  apply() { // Drafts to live sections
    const selectedDraftSection: Array<SectionsForPageViewModel> = filter(this.allSections, (eachAllSections) =>
      eachAllSections.sectionId === +this.selectedSectionsDraftId[0]);
    const totalLiveSections = (filter(this.allSections, (eachAllSections) => !eachAllSections.isDraftMode)).length;
    if (selectedDraftSection && selectedDraftSection.length) {
      if (selectedDraftSection[0].isMoved) {
        const matchingDraftSection = filter(this.allSections, (eachAllSections) =>
          eachAllSections.refContainerId === +this.selectedSectionsDraftId[0]);
        if (matchingDraftSection && matchingDraftSection.length) {
          matchingDraftSection[0].isDeleted = false;
          matchingDraftSection[0].isMoved = false;
          matchingDraftSection[0].orderBy = selectedDraftSection[0].orderBy;
          if (!matchingDraftSection[0].isDeletedByUser) {
            this.deletedSections = reject(this.deletedSections, (val) => {
              return val.sectionId === matchingDraftSection[0].sectionId;
            });
          }
        }
        forEach(this.allSections, (val) => {
          if (val.sectionId === selectedDraftSection[0].sectionId) {
            val.isDraftMode = false;
            val.isMoved = false;
            val.orderBy = val.oldOrderBy;
          }
        });
      } else {
        forEach(this.allSections, (val) => {
          if (val.sectionId === selectedDraftSection[0].refContainerId) {
            selectedDraftSection[0].isDraftMode = false;
            selectedDraftSection[0].isMoved = true;
            selectedDraftSection[0].orderBy = val.orderBy;
            val.isDraftMode = false;
            val.isDeleted = true;
            val.isMoved = true;
            if (val.isDeletedByUser !== true) {
              const sect = cloneDeep(val);
              sect.sectionTitle += ' (Original)';
              this.deletedSections.push(sect);
            }
          }
        });
        const checkRefSectionInLive = filter(this.allSections, (eachAllSections) =>
          eachAllSections.sectionId === selectedDraftSection[0].refContainerId);
        if (!(checkRefSectionInLive && checkRefSectionInLive.length)) {
          selectedDraftSection[0].isDraftMode = false;
          selectedDraftSection[0].isMoved = true;
          selectedDraftSection[0].orderBy = totalLiveSections + 1;
        }
      }
    }
    this.selectedSectionsDraft = [];
    this.selectedSectionsDraftId = [];
    this.allSections = orderBy(this.allSections, ['orderBy']);
    this.allSections = this.updateOrder(this.allSections, false);
  }

  remove() {
    let selectedDraftSections = filter(this.allSections, (eachAllSections) =>
      eachAllSections.refContainerId === +this.selectedSectionsLiveId[0]);
    const totalDraftSections = (filter(this.allSections, (eachAllSections) => eachAllSections.isDraftMode)).length;
    const selectedLiveSection = filter(this.allSections, (eachAllSections) =>
      eachAllSections.sectionId === +this.selectedSectionsLiveId[0]);

    if (selectedLiveSection && selectedLiveSection.length && selectedLiveSection[0].isMoved) {
      selectedLiveSection[0].isDraftMode = true;
      selectedLiveSection[0].isMoved = false;

      const matchingLiveSection = filter(this.allSections, (eachAllSections) =>
        eachAllSections.sectionId === selectedLiveSection[0].refContainerId);
      if (matchingLiveSection && matchingLiveSection.length) {
        matchingLiveSection[0].isDeleted = false;
        matchingLiveSection[0].isMoved = false;
        matchingLiveSection[0].orderBy = selectedLiveSection[0].orderBy;
        if (!matchingLiveSection[0].isDeletedByUser) {
          this.deletedSections = reject(this.deletedSections, (val) => val.sectionId === matchingLiveSection[0].sectionId);
        }
      }
    } else {
      if (selectedDraftSections && selectedDraftSections.length && !selectedDraftSections[0].isDeleted
        && !selectedDraftSections[0].isDeletedByUser) {
        const displayText = 'Are you sure you want to overwrite the draft content?';
        if (confirm(displayText)) {
          forEach(this.allSections, (val) => {
            if (val.sectionId === selectedDraftSections[0].sectionId) {
              val.isDeleted = true;
              const sect = cloneDeep(val);
              sect.sectionTitle += ' (Draft)';
              this.deletedSections.push(sect);
            }
            if (val.sectionId === selectedDraftSections[0].refContainerId) {
              val.isDeleted = false;
              val.isMoved = true;
              val.isDraftMode = true;
              val.oldOrderBy = val.orderBy;
              val.orderBy = selectedDraftSections[0].orderBy;
            }
          });
        }
      } else {
        selectedDraftSections = filter(this.allSections, (eachAllSections) =>
          eachAllSections.sectionId === +this.selectedSectionsLiveId[0]);
        if (selectedDraftSections && selectedDraftSections.length) {
          selectedDraftSections[0].isDraftMode = true;
          selectedDraftSections[0].isMoved = true;
          selectedDraftSections[0].oldOrderBy = selectedDraftSections[0].orderBy;
          selectedDraftSections[0].orderBy = totalDraftSections + 1;
        }
      }
    }
    this.selectedSectionsLive = [];
    this.selectedSectionsLiveId = [];
    this.allSections = orderBy(this.allSections, ['orderBy']);
    this.allSections = this.updateOrder(this.allSections, true);
  }
}
